<template>
  <div>
    <!-- 沒拿到 token 時的異常處理 -->
    <div v-if="getIsSetSessionWrong" class="no-post">
      <h6>系統異常，請重新開啟 Lale</h6>
    </div>
    <!-- 無動態時的 UI -->
    <div v-if="getPostWallLoadStatus && getPostWallData.length === 0" class="no-post">
      <!-- 貼文牆無資料可能是因為他不允許看到非好友貼文，而他的朋友都沒發文 -->
      <template v-if="$route.name === 'PostWall'">
        <img src="@/assets/img/no_friends_post.png" />
        <p class="no-post-p">沒有朋友動態?</p>
        <q-btn class="width-btn" color="lale-secondary" label="去找朋友" unelevated />
        <q-btn class="width-btn" color="lale-primary" label="看陌生人" unelevated />
      </template>
      <!-- 查看沒發過文的人的友圈 或是 自己沒發過文的自己貼文牆 -->
      <h6 v-else>這裡沒有任何動態</h6>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ExceptionWall',
  computed: {
    ...mapGetters('PostWallModule', ['getPostWallLoadStatus', 'getPostWallData']),
    ...mapGetters(['getIsSetSession', 'getIsSetSessionWrong'])
  }
};
</script>

<style scoped lang="scss">
.no-post {
  text-align: center;
  margin-top: 150px;
  color: $LaleGray8;

  img {
    width: 65%;
  }

  .no-post-p {
    color: $LaleNotActiveGray;
    margin-top: 20px;
  }
}

.width-btn {
  border-radius: 25px;
  padding: 2px 15px;
  margin: 15px;
  font-size: 16px;
  font-weight: 700;
}
</style>
